import { List } from 'immutable';
import _ from 'underscore';
import * as HistoryBetActions from '../../actions/coupon/betTypes';
import { CLEAR_BETSLIPS } from '../../actions/coupon/coupon';
import * as BetTypes from '../../constants/BetType';
export default function betTypesReducer(betTypes, betSlips, action) {
    switch (action.type) { //eslint-disable-line default-case
        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
            if (action.data && action.data.Error === undefined && action.data.message === undefined) {
                betTypes = fillBetTypes(betSlips, action.data);
            }
            return betTypes;
        case CLEAR_BETSLIPS:
            return new List();
    }
    return betTypes;
}
function fillBetTypes(betSlips, data) {
    if (data.error) {
        return new List();
    }
    var betTypes = new List(data.BetTypes);
    var antiExpressOdd = Math.ceil((data.AntiExpressOdd) * 100) / 100;
    var extendedBetTypes = new List();
    var ratesCount = betSlips.size;
    var rateValues = betSlips.valueSeq().map(function (bs) { return bs.getIn(['rate', 'value']); }).toArray();
    for (var i = 0; i < betTypes.size; i++) {
        var betTypeId = betTypes.get(i);
        var odd = 0;
        switch (betTypeId) { //eslint-disable-line default-case
            case BetTypes.SINGLE:
                odd = _.reduce(rateValues, function (sum, r) { return sum + r; }, 0);
                extendedBetTypes = extendedBetTypes.push({
                    type: BetTypes.SINGLE,
                    odd: odd
                });
                break;
            case BetTypes.EXPRESS:
                odd = _.reduce(rateValues, function (prod, r) { return prod * r; }, 1);
                extendedBetTypes = extendedBetTypes.push({
                    type: BetTypes.EXPRESS,
                    odd: Math.ceil((odd) * 100) / 100
                });
                break;
            case BetTypes.SYSTEM:
                for (var rank = 2; rank < ratesCount; rank++) {
                    odd = getSystemOdd(rateValues, rank);
                    extendedBetTypes = extendedBetTypes.push({
                        type: betTypeId,
                        rank: rank,
                        count: ratesCount,
                        odd: Math.ceil((odd) * 100) / 100,
                        rawOdd: odd
                    });
                }
                break;
            case BetTypes.ANTIEXPRESS:
                extendedBetTypes = extendedBetTypes.push({
                    type: BetTypes.ANTIEXPRESS,
                    odd: antiExpressOdd
                });
                break;
        }
    }
    return extendedBetTypes;
}
function getSystemOdd(rates, rank) {
    function recursiveGetCombinations(rates, rank, index, tempArr, result) {
        for (var i = index; i < rates.length; i++) {
            (function (index) {
                var rateArr = tempArr.slice(0);
                rateArr.push(rates[index]);
                if (rank > 1) {
                    return recursiveGetCombinations(rates, rank - 1, index + 1, rateArr, result);
                }
                else {
                    result.push(rateArr);
                }
            })(i);
        }
        return result;
    }
    var tempArr = [];
    var resultArr = [];
    var combinations = recursiveGetCombinations(rates, rank, 0, tempArr, resultArr);
    var odd = 0;
    for (var i = 0; i < combinations.length; i++) {
        var combination = combinations[i];
        var expressOdd = _.reduce(combination, function (prod, r) { return prod * r; }, 1);
        odd = odd + expressOdd / combinations.length;
    }
    return odd;
}



// WEBPACK FOOTER //
// ./src/reducers/coupon/betTypesReducer.js